/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { FormattedMessage } from 'react-intl';
import Container from './components/Container';
import LabelContainer from './components/LabelContainer';
import InputContainer from './components/InputContainer';
import StyledLabel from './components/StyledLabel';

const SideText = styled.span`
  padding-left: 8px;
  font-weight: bold;
  font-size: 14px;
  ${({ inInput }) => {
    if (inInput) {
      return css`
        margin-right: 8px;
      `;
    }

    return null;
  }}
`;

const MessageContainer = styled.div`
  ${({ errorSpacing }) => !errorSpacing
    && css`
      position: absolute;
      margin-bottom: 4px;
    `}
  width: calc(100% - 2px);
  background: transparent;
  z-index: 5;
`;

const MessageOuterContainer = styled.div`
  position: relative;
  width: ${({ width }) => width || '100%'};
  display: ${({ visible }) => !visible && 'none'};
`;

const Message = styled.div`
  display: flex;
  padding-top: ${({ errorInLabel }) => (errorInLabel ? '0px' : '5px')};
  padding-left: 5px;
  white-space: normal;
  font-size: 14px;
  color: ${({ theme }) => (theme ? theme.danger : '#e74c3c')};
  justify-content: ${({ justifyErrorMessage }) => justifyErrorMessage || 'flex-start'};
`;

const LabelErrorMessageContainer = styled.div``;

const InputWrapper = (props) => {
  if (!props.children) {
    return null;
  }

  const showError = props.error && props.error !== 'Form.Error.required-field';
  return (
    <Container
      paddingRight={props.paddingRight}
      width={props.width}
      addWidth={props.addWidth}
      flexDirection={props.flexDirection}
      noMobileWidth={props.noMobileWidth}
    >
      {props.label && props.showLabel && (
        <LabelContainer errorInLabel={props.errorInLabel} labelWidth={props.labelWidth}>
          <StyledLabel
            errorInLabel={props.errorInLabel && showError}
            margin={props.margin}
            width={props.width}
            labelColor={props.labelColor}
            unBoldLabel={props.unBoldLabel}
          >
            <FormattedMessage id={props.label} />
            {props.star && <span style={{ color: props.star }}>*</span>}
          </StyledLabel>
          {props.errorInLabel && showError && (
            <LabelErrorMessageContainer width={props.width} visible={props.error}>
              <Message errorInLabel={props.errorInLabel}>
                <FormattedMessage id={props.error} />
              </Message>
            </LabelErrorMessageContainer>
          )}
        </LabelContainer>
      )}
      <InputContainer
        error={props.error}
        border={props.border}
        rightSideInInput={props.rightSideText.inInput && props.rightSideText.inInput}
        disabled={props.disabled}
      >
        {React.cloneElement(props.children, { ...props, children: undefined })}
        {props.rightSideText && props.rightSideText.show !== false && (
          <SideText {...props.rightSideText}>
            {props.rightSideText.text || props.rightSideText}
          </SideText>
        )}
      </InputContainer>
      {!props.errorInLabel && showError && (
        <MessageOuterContainer width={props.width} visible={props.error}>
          <MessageContainer errorSpacing={props.errorSpacing}>
            <Message justifyErrorMessage={props.justifyErrorMessage}>
              <FormattedMessage id={props.error} />
            </Message>
          </MessageContainer>
        </MessageOuterContainer>
      )}
    </Container>
  );
};

InputWrapper.defaultProps = {
  addWidth: false,
  align: '',
  autoComplete: '',
  autoFocus: false,
  border: null,
  disabled: false,
  error: null,
  errorInLabel: false,
  errorSpacing: false,
  flexDirection: 'column',
  fontSize: '',
  height: '',
  justifyErrorMessage: 'flex-start',
  label: '',
  labelWidth: 'unset',
  margin: true,
  maxLength: 100,
  normalize: '',
  onBlur: () => null,
  onChange: () => null,
  onKeyPress: () => null,
  paddingRight: false,
  placeholder: null,
  rightSideText: '',
  showLabel: true,
  star: '',
  tabIndex: '0',
  tabTo: null,
  type: 'text',
  value: '',
  width: '',
  labelColor: '',
  unBoldLabel: false,
  noMobileWidth: false,
};

InputWrapper.propTypes = {
  addWidth: PropTypes.bool,
  align: PropTypes.string,
  autoComplete: PropTypes.string,
  autoFocus: PropTypes.bool,
  border: PropTypes.string,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /** Moves the error message up to the label */
  errorInLabel: PropTypes.bool,
  errorSpacing: PropTypes.bool,
  flexDirection: PropTypes.string,
  fontSize: PropTypes.string,
  height: PropTypes.string,
  /** Sets the justifyContent value of the error message */
  justifyErrorMessage: PropTypes.string,
  label: PropTypes.string,
  labelWidth: PropTypes.string,
  margin: PropTypes.bool,
  maxLength: PropTypes.number,
  name: PropTypes.string.isRequired,
  normalize: PropTypes.string,
  onBlur: PropTypes.func,
  onKeyPress: PropTypes.func,
  onChange: PropTypes.func,
  paddingRight: PropTypes.bool,
  placeholder: PropTypes.string,
  rightSideText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  showLabel: PropTypes.bool,
  /** Adds a star next to the input field, indicating that it's required. */
  star: PropTypes.string,
  /** Explicitly sets the tabIndex for the input.
   * Be careful with this, as this can mess up keyboard navigation.
   * */
  tabIndex: PropTypes.string,
  tabTo: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.string,
  labelColor: PropTypes.string,
  unBoldLabel: PropTypes.bool,
  noMobileWidth: PropTypes.bool,
};

export default InputWrapper;
